import { render, staticRenderFns } from "./GenericRegionView.vue?vue&type=template&id=d8f02c36&"
import script from "./GenericRegionView.vue?vue&type=script&lang=js&"
export * from "./GenericRegionView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports